/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { seriesRolesArray } from 'jotai/auth/AuthObject';
import { authService } from 'services/auth/AuthService';

const isOnlyIndyUser = () => {
  const userRoles = authService.getRolesAllRealms();
  return userRoles.includes(AuthRoles.Indy) && userRoles.filter((role) => seriesRolesArray.includes(role as AuthRoles)).length === 1 && !userRoles.includes(AuthRoles.ADMIN);};

export default isOnlyIndyUser;
